import React from 'react';
import * as TFF from '@tff/types/tff';
import { useIntl } from 'react-intl';
import TFFTypography from '../../styled-components/TFFTypography';
import TFFIcon from '../../styled-components/TFFIcon';
import { useBookingContext } from '../../hooks/use-booking-context';
import { isNdcOrNdcxBookingSource } from '../../util/booking-type-utils';
import { getNdcBaggageText } from '../../util/ancillary-utils';

interface props {
  ancillary: TFF.Ancillary;
  isOutbound: boolean;
  bookingSource?: TFF.TffBookingSource;
}

const AncillaryRow: React.FC<props> = ({ ancillary, isOutbound, bookingSource }) => {
  const intl = useIntl();
  const { costFormatter } = useBookingContext();
  const isNdc = bookingSource ? isNdcOrNdcxBookingSource(bookingSource) : false;

  const getNdcAncillaryText = (): string => {
    const baggageText = getNdcBaggageText(ancillary, intl);
    if (baggageText) return baggageText;

    const description = ancillary.Description || '';
    const value = ancillary.Value ? ' (' + ancillary.Value + ')' : '';
    return description + value;
  };

  const getAncillaryDescription = (): string => {
    const isBiOrTfaType = (ancillary.Type.startsWith('BI') || ancillary.TfaDetails) && ancillary.Type !== 'SEAT';

    if (isBiOrTfaType) {
      const isEnglish = intl.locale === 'en-US';
      return isEnglish
        ? ancillary.TfaDetails?.DescriptionEN || ancillary.Value
        : ancillary.TfaDetails?.DescriptionDE || ancillary.Value;
    }

    if (ancillary.Type === 'SEAT') {
      return ancillary.Value;
    }

    return ancillary.Description ?? '';
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: isOutbound ? '340px' : '300px',
      }}
    >
      <TFFTypography
        text={
          <>
            {ancillary.Type === 'SEAT' && (
              <span className="tff-cabin-class-icon">
                <TFFIcon iconName="seat" />
              </span>
            )}
            {isNdc ? (
              getNdcAncillaryText()
            ) : (
              getAncillaryDescription()
            )}
          </>
        }
        extraStyle={{
          display: 'flex',
        }}
        color={
          ancillary.Note === 'ATCOM' || ancillary.Type === 'SEAT' || ancillary.Type === 'INF' || isNdc
            ? 'color-functional-neutral-900'
            : 'color-functional-neutral-400'
        }
      />
      <TFFTypography
        size="small"
        text={isNdc ? 'incl.' : costFormatter.format(ancillary?.TotalAmount! ?? 0)}
      />
    </div>
  );
};

export default AncillaryRow;
